import { useMemo } from "react";
import { useLocation } from "react-router";

import { history } from "@/routing";

// The URL is the single source of truth for the Load Finder selection:
//   ?truck=<truckId>                → strategy view (radio on) when the truck has a strategy
//   ?truck=<truckId>&filter=<id>   → filter view
//   ?truck=<truckId>&strategy=off  → plain "all loads" view (radio off)
// Clicks rewrite the URL; rendering derives from it. Defaults are applied by the
// page redirecting an incomplete URL to its canonical form.
export const replaceLoadFinderSelection = ({ truckId, filterId, strategyOff = false }) => {
  const params = new URLSearchParams(history.location.search);
  if (truckId != null) params.set("truck", String(truckId));
  else params.delete("truck");
  if (filterId != null) params.set("filter", String(filterId));
  else params.delete("filter");
  params.delete("post");
  if (strategyOff) params.set("strategy", "off");
  else params.delete("strategy");
  const search = params.toString();
  const nextSearch = search ? `?${search}` : "";
  if (nextSearch !== history.location.search) {
    history.replace(`${history.location.pathname}${nextSearch}`);
  }
};

export const useLoadFinderUrlSelection = () => {
  const location = useLocation();
  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      truckParam: params.get("truck"),
      filterParam: params.get("filter") ?? params.get("post"),
      strategyOffParam: params.get("strategy") === "off",
    };
  }, [location.search]);
};
